import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-2 w-100 bb-solid-white100 mb-2" }
const _hoisted_2 = { class: "d-flex j-content-end a-i-start w-100 pagenation" }
const _hoisted_3 = { class: "w-100" }

import PaginationComponent from "@/components/pagination/paginationComponent.vue";
import NotFoundResults from "@/components/notFoundResults/notFoundResults.vue";
import LoadingComponent from "@/components/loading/loadingComponent.vue";
import ErrorComponent from "@/components/error/errorComponent.vue";
import { ICartCars } from "@/store/modules/Cart/type";
import { IResultSearchStore, CARS } from "@/store/modules/Search/type";
import { computed, onBeforeMount, ref } from "vue";
import { IStore } from "@/store/types/StoreType";
import { useStore } from "vuex";

import FilterResultsComponent_KK from "../../filter/filterResults_KK/filterResultsComponent_KK.vue";
import ResultsComponent_KK from "../../resultComponent/resultsComponentKK.vue";

import FilterResultsComponent_KM from "../../filter/filterResults_KM/filterResultsComponent_KM.vue";
import ResultsComponent_KM from "../../resultComponent/resultsComponentKM.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'carsResultsComponents',
  setup(__props) {

const store = useStore<IStore>();

const carSearchResults = ref<IResultSearchStore<CARS>>(
  store?.getters?.getSearchCars
);

const updateCars = (link: string) =>
  link && store.dispatch("GetCars", { url: link });

const customerType = ref(
  computed<string>(() => store.getters.getUserCustomerTypeData)
);
const cartData = ref(computed<ICartCars[]>(() => store.getters.getCart));

onBeforeMount(() => {
  store.dispatch("GetBrandCars");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (customerType.value === 'Reseller')
      ? _withDirectives((_openBlock(), _createBlock(FilterResultsComponent_KM, { key: 0 }, null, 512)), [
          [_vShow, carSearchResults.value.results.length > 0 && !carSearchResults.value.isLoading]
        ])
      : _withDirectives((_openBlock(), _createBlock(FilterResultsComponent_KK, { key: 1 }, null, 512)), [
          [_vShow, carSearchResults.value.results?.length > 0 && !carSearchResults.value.isLoading]
        ]),
    _withDirectives(_createElementVNode("section", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carSearchResults.value.results, (car) => {
        return (_openBlock(), _createElementBlock("article", {
          class: "text-motserrat-14",
          key: car.product_tyre.id + car.product_full_name + car.amount
        }, [
          (customerType.value === 'Reseller')
            ? (_openBlock(), _createBlock(ResultsComponent_KM, {
                key: 0,
                info: car,
                cart: cartData.value?.find((_cart) => (_cart.id === car.product_tyre.id && _cart.stock_name === _cart.stock_name))
              }, null, 8, ["info", "cart"]))
            : (_openBlock(), _createBlock(ResultsComponent_KK, {
                key: 1,
                info: car,
                cart: cartData.value?.find((_cart) => (_cart.id === car.product_tyre.id  && _cart.stock_name === _cart.stock_name))
              }, null, 8, ["info", "cart"]))
        ]))
      }), 128))
    ], 512), [
      [_vShow, carSearchResults.value.results.length > 0 && !carSearchResults.value.isLoading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(PaginationComponent, {
          total_info: true,
          total: carSearchResults.value.count || 0,
          pageSize: '100',
          linkNext: carSearchResults.value.next,
          linkPrev: carSearchResults.value.previous,
          link: carSearchResults.value.next || carSearchResults.value.previous || '',
          callback: updateCars
        }, null, 8, ["total", "linkNext", "linkPrev", "link"]), [
          [_vShow, carSearchResults.value.count && carSearchResults.value.count > 0]
        ])
      ])
    ], 512), [
      [_vShow, !carSearchResults.value.isLoading]
    ]),
    _withDirectives(_createVNode(ErrorComponent, null, null, 512), [
      [_vShow, carSearchResults.value.isError]
    ]),
    _withDirectives(_createVNode(LoadingComponent, null, null, 512), [
      [_vShow, 
      typeof carSearchResults.value.next === 'string' &&
      carSearchResults.value.isLoading &&
      !carSearchResults.value.isError
    ]
    ]),
    _withDirectives(_createVNode(NotFoundResults, null, null, 512), [
      [_vShow, 
      carSearchResults.value.results.length === 0 && !carSearchResults.value.isLoading
    ]
    ])
  ], 64))
}
}

})